import React from 'react';
import Chase_Banner from "images/chase/HH50-Chase-Landing-banner.jpg";

export default () => {
  return <div className="chase__banner">
  <img src={Chase_Banner}/>
</div>
    ;
}